import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  { number: '1', title: 'Cadastre-se', text: 'Cadastre-se para seu teste gratuito de 14 dias (Sem compromisso) + Ganhe o eBook' },
  { number: '2', title: 'Avaliação', text: 'Complete a avaliação fitness' },
  { number: '3', title: 'Receba o Plano', text: 'Receba seu plano de treino personalizado' },
  { number: '4', title: 'Comece a Treinar', text: 'Treine com meu app, acompanhe seu progresso e comece a ver os resultados!' }
];

class HowItWorks extends React.Component {
  render() {
    return (
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-3xl font-bold text-center mb-12"
          >
            Como Funciona
          </motion.h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2, duration: 0.8 }}
                viewport={{ once: true }}
                className="text-center"
              >
                <div className="w-16 h-16 bg-blue-500 rounded-full text-white text-2xl font-bold flex items-center justify-center mx-auto mb-4">
                  {step.number}
                </div>
                <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default HowItWorks;
